import {Nilable} from 'utilities/common/types';
import {DeliveryAddress} from 'utilities/location';

export enum AppId {
  Optimus = 'gid://shopify/App/12882051073',
}

export enum BrandHandle {
  ShopPromise = 'shop_promise',
  Prime = 'buy_with_prime',
}

export interface Image {
  src: string;
  altText: string;
}

export interface BrandedPromise {
  name: string;
  handle: BrandHandle;
  lightLogo: Image;
  darkLogo: Image;
  learnMoreURL?: string;
  sdkURL?: string;
}

export interface DeliveryOption {
  deliveryPromisePresentmentTitle: string;
  minDeliveryTime: string | null;
  maxDeliveryTime: string | null;
  minBusinessDaysToDelivery: number | null;
  maxBusinessDaysToDelivery: number | null;
  minCalendarDaysToDelivery: number | null;
  maxCalendarDaysToDelivery: number | null;
  deliveryDates: string | null;
  expiresAt: string | null;
  cost: {
    amount: string | null;
  };
  brandedPromise: BrandedPromise | null;
  deliveryPromiseProviderAppId?: AppId;
  reliableDateSource: boolean;
}

export interface FreeDeliveryThreshold {
  amount: number;
  currencyCode: string;
}

export interface DeliveryEstimates {
  options: DeliveryOption[];
  selectedShippingOption: DeliveryOption | null;
  productHandle: string;
  deliveryAddress: DeliveryAddress;
  renderEstimates: boolean;
  deliveryDateMissingReason: string | null;
  freeDeliveryThreshold?: FreeDeliveryThreshold | null;
  variant: string;
  product: string;
}

export interface DeliveryEstimateState {
  variantId: number | null;
  deliveryEstimates: DeliveryEstimates | null;
}

export interface QueryMetadata {
  datacenter?: string;
  shardId?: string;
  requestId?: string;
}

export interface DeliveryEstimatesData {
  deliveryEstimates: DeliveryEstimates;
}

export interface DeliveryEstimatesRequestParameters {
  variantId: number;
  sellingPlanId?: Nilable<number>;
  postalCode?: string | null;
  defaultPostalCode?: string;
  theme?: string;
}

export type DeliveryPromiseAPIClient = (
  deliveryEstimatesRequestParams: DeliveryEstimatesRequestParameters,
  storefrontAPIAccessToken: string,
) => Promise<DeliveryEstimates & QueryMetadata>;

export interface APISubscriberCallbackFns {
  onSuccess: (result: DeliveryEstimates & QueryMetadata) => void;
  onFail: (reason: any) => any;
}
